import * as types from './constants';

// Get Billing Invoices
export const getBillingInvoicesRequest = data => (
  { type: types.GET_BILLING_INVOICES_REQUEST, payload: data }
);

export const getBillingInvoicesDone = data => (
  { type: types.GET_BILLING_INVOICES_DONE, payload: data }
);

export const getBillingInvoicesFailed = errors => (
  { type: types.GET_BILLING_INVOICES_FAILED, payload: errors }
);

export const getBillingInvoicesReset = () => (
  { type: types.GET_BILLING_INVOICES_RESET }
);

export const billingInvoicesSetPage = data => (
  { type: types.BILLING_INVOICES_SET_PAGE, payload: data }
);